import React, { forwardRef } from 'react';
import styled from 'styled-components';
import type { IconButtonProps } from './index.d';
import {
    IconButtonNone,
    IconButtonDefault,
    IconButtonSecondary,
    IconButtonThird,
    IconButtonDisabled,
    IconButtonColored,
    IconButtonOnButton,
} from './view';

/*
    Component wrapper for icons.
    Icon button types 'none' | 'default' | 'secondary' | 'third' | 'disabled' | 'colored' | 'onButton'
    Icon button sizes 'small' | 'medium'
*/

export const COMPONENT_MAPPING = {
    none: IconButtonNone,
    default: IconButtonDefault,
    secondary: IconButtonSecondary,
    third: IconButtonThird,
    disabled: IconButtonDisabled,
    colored: IconButtonColored,
    onButton: IconButtonOnButton,
};

const IconButton = forwardRef<
    HTMLButtonElement,
    IconButtonProps & {
        type?: 'submit' | 'button' | 'reset';
        as?: string;
    }
>((props, buttonRef) => {
    const {
        children,
        className,
        color,
        disabled = false,
        focusVisibleClassName,
        variant = 'none',
        cy,
        ...other
    } = props;
    const Component = COMPONENT_MAPPING[variant];
    const isDisabled = disabled || variant === 'disabled';

    return (
        <Component
            ref={buttonRef}
            className={className}
            disabled={isDisabled}
            data-cy={cy}
            {...other}
        >
            {children}
        </Component>
    );
});

IconButton.displayName = 'IconButton';

export default styled(IconButton)``;
